// extracted by mini-css-extract-plugin
export default {"dataDeletePendingNotice":"Connections_dataDeletePendingNotice__3ysPZ"};